"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const call_state_1 = __importDefault(require("./call_state"));
const top_toolbar_styles_1 = require("./top_toolbar.styles");
const app_icon_1 = require("../icons/app_icon");
const tool_bar_icon_1 = __importDefault(require("./tool_bar_icon"));
const button_1 = __importDefault(require("../buttons/button"));
const TopToolbar = ({ tools, userName, connectionQuality }) => {
    const [activeToolIndex, setActiveToolIndex] = (0, react_1.useState)(null);
    const callControls = [
        { iconName: 'MuteIcon' },
        { iconName: 'FlashlightIcon' },
        { iconName: 'RecordingIcon' },
    ];
    // onClick arg. placeholder until future component specs direct cleaner handleToolClick refactor.
    const handleToolClick = (toolIndex, onClick) => {
        setActiveToolIndex(toolIndex);
        onClick();
    };
    return ((0, jsx_runtime_1.jsxs)(top_toolbar_styles_1.Wrapper, { children: [(0, jsx_runtime_1.jsx)(top_toolbar_styles_1.LeftToolbar, Object.assign({ alignItems: "center" }, { children: tools.map((tool, index) => {
                    if (tool.isHidden) {
                        return;
                    }
                    const active = activeToolIndex === index;
                    return ((0, jsx_runtime_1.jsx)(tool_bar_icon_1.default, { tool: tool, active: active, handleClick: () => handleToolClick(index, tool.onClick) }, index));
                }) })), (0, jsx_runtime_1.jsx)(top_toolbar_styles_1.CenterToolbar, Object.assign({ alignItems: "center", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(call_state_1.default, { name: userName, callState: "active", connectionQuality: connectionQuality }) })), (0, jsx_runtime_1.jsxs)(top_toolbar_styles_1.RightToolbar, Object.assign({ alignItems: "center" }, { children: [callControls.map((tool, index) => {
                        return (0, jsx_runtime_1.jsx)(tool_bar_icon_1.default, { tool: tool }, index);
                    }), (0, jsx_runtime_1.jsxs)(button_1.default, Object.assign({ variant: 'danger', size: 'skinny' }, { children: [(0, jsx_runtime_1.jsx)(app_icon_1.AppIcon, { name: "EndCallIcon" }), "End Streem"] }))] }))] }));
};
exports.default = TopToolbar;
//# sourceMappingURL=top_toolbar.js.map